import Stars from '@mui/icons-material/Stars'
import PrizeList from './list'

const exp = {
  icon: Stars,
  list: PrizeList
}

export default exp
